import { Component, Input, OnInit } from '@angular/core';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';

@Component({
    selector: 'error-filter',
    templateUrl: './error-filter.component.html',
    styleUrls: ['./error-filter.component.scss']
})

export class TfErrorFilterComponent implements OnInit {

    @Input() keyword: string;
    @Input() productType: string;

    isFisherSci: boolean = false;

    constructor(private productSiteRegionService: ProductSiteRegionService) {}

    ngOnInit(): void {

        if (this.productSiteRegionService.isFisherSci() == true) {
            this.isFisherSci = true;
        }

    }

    getProductTypeMessage(){
        let message = '';
        if(this.productType && this.productType === 'gx'){
            message = 'TaqMan Arrays';
        }else{
            message = 'TaqMan Assays'
        }
        return message;
    }
    
    getContactUrl(): string {
        if (this.isFisherSci === true) {
            return `/us/en/customer-help-support.html?cid=OBC_INT_20200507_XTD27A`;
        }
        return `/us/en/home/technical-resources/contact-us.html?supportType=TS`;
    }
}
